import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

export function getBalance() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/VCurrency/Balance/GetBalance`,
    method: 'get'
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

export function getStastics() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/VCurrency/Balance/GetStastics`,
    method: 'get'
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}
export function getIncomeExpenditurePage(pageIndex, pageSize) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/VCurrency/Balance/GetIncomeExpenditurePage`,
    method: 'post',
    data: {
      indexPageRequest: {
        pageIndex: pageIndex,
        pageSize: pageSize
      }
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}

/**
 * 查询充值状态
 * @param orderId
 * @return {Promise<*>}
 */
export async function getRechargeInfo(orderId) {
  return axios.get(`${Urls.DOMAIN_YKT}/VCurrency/Recharge/GetRechargeInfo`, {
    params: {
      id: orderId
    }
  })
}

/**
 * 获取财币充值列表
 * @return {*}
 */
export function getAllFaceValues() {
  return axios
    .get(`${Urls.DOMAIN_YKT}/VCurrency/Data/AllFaceValues`)
    .then(data => {
      let detail = []
      if (data.result.code === 0) {
        detail = data.detail
      }

      return detail
    })
    .catch(() => [])
}

/**
 * 创建充值订单
 * @param id
 * @param payMethod
 * @param tradeType
 * @param appId
 * @return {Promise<*>}
 */
export async function createRechargeOrder(id, payMethod, tradeType, appId) {
  return axios.get(`${Urls.DOMAIN_YKT}/VCurrency/Recharge/RechargePayOrder`, {
    params: {
      /**
       * 资产类型
       */
      assetTypes: 0,
      faceValueId: id,
      paymentMethod: payMethod,
      tradeType: tradeType,
      appId: appId
    }
  })
}
